const t = new Proxy(
  {},
  {
    get(e, i) {
      if (typeof i == "string" && i.startsWith("iui-"))
        return i.replace("iui-", "_iui3-");
    },
    has(e, i) {
      return typeof i == "string" && i.startsWith("iui-");
    }
  }
);
export {
  t as default
};
